import '../styles/output.css';
import '../styles/global.css';
let Banner=()=>{
    return (
        <span className='w-1 h-6 mr-2 bg-yellow-400 rounded-lg'></span>
    )
}
export default Banner